import React from 'react';
import { CheckIcon, ChevronLeftIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
const optional = [{
  title: 'Contact from the brand',
  note: 'Optional. Your entry counts either way.'
}, {
  title: 'Marketing updates',
  note: 'Optional. Turn on or off anytime.'
}];
export function ConsentScreen() {
  return <div className="flex h-full flex-col bg-canvas" data-id="element-254" data-mp="21udij60w5qsx">
      <StatusBar data-id="element-255" data-mp="1ww3nqwj2ws7u" />
      <div className="px-4 pt-5" data-id="element-256" data-mp="1wwloa5crxslk">
        <span className="grid h-8 w-8 place-items-center rounded-full bg-white ring-1 ring-line" data-id="element-257" data-mp="1wxn1ogh9ir6g">
          <ChevronLeftIcon className="h-4 w-4" data-id="element-258" data-mp="1s2qxkhyr4dcz" />
        </span>
      </div>
      <div className="flex-1 px-5 pt-5" data-id="element-259" data-mp="1n6jz1a8oq452">
        <p className="font-display text-[22px] font-extrabold leading-tight tracking-tight" data-id="element-260" data-mp="1j45jp0485mij">Your choices</p>
        <p className="mt-1.5 text-[10.5px] leading-snug text-muted" data-id="element-261" data-mp="1e4sxmhl6gjh0">
          Decide what you share. Change it anytime in your privacy center.
        </p>

        <div className="mt-5 space-y-2" data-id="element-262" data-mp="196hknxzl5suk">
          <div className="flex items-center gap-3 rounded-2xl bg-white p-3 ring-1 ring-line" data-id="element-263" data-mp="4iy4yiyoce1w">
            <div className="flex-1" data-id="element-264" data-mp="99eis46eq1os">
              <p className="text-[11px] font-bold" data-id="element-265" data-mp="9ag4d2l1u6kr">Action rules & privacy info</p>
              <p className="mt-0.5 text-[9px] text-muted" data-id="element-266" data-mp="3rnxge9kt8tl1">Read before taking part</p>
            </div>
            <span className="grid h-6 w-6 place-items-center rounded-full bg-forest" data-id="element-267" data-mp="gb9m82soazy">
              <CheckIcon className="h-3.5 w-3.5 text-mint" strokeWidth={3} data-id="element-268" data-mp="o65kik3jzphk" />
            </span>
          </div>
          {optional.map(o => <div key={o.title} className="flex items-center gap-3 rounded-2xl bg-white p-3 ring-1 ring-line" data-id="element-269" data-mp="s7qv1ysm7rol">
              <div className="flex-1" data-id="element-270" data-mp="e8987oyvqohv">
                <p className="text-[11px] font-bold" data-id="element-271" data-mp="j7c8yx7tu8k1">{o.title}</p>
                <p className="mt-0.5 text-[9px] text-muted" data-id="element-272" data-mp="j9owdpwctb4h">{o.note}</p>
              </div>
              <span className="flex h-5 w-9 items-center rounded-full bg-line p-0.5" data-id="element-273" data-mp="2yxf90wd2061t">
                <span className="h-4 w-4 rounded-full bg-white shadow" data-id="element-274" data-mp="33zea1zlbmqvl" />
              </span>
            </div>)}
        </div>
        <p className="mt-4 text-[9.5px] leading-snug text-muted" data-id="element-275" data-mp="2fu3k8j55b0r0">
          Nothing is pre-ticked. Answers and choices are stored separately.
        </p>
      </div>
      <div className="px-5 pb-7" data-id="element-276" data-mp="2b1tw98nlcard">
        <span className="flex h-11 items-center justify-center rounded-full bg-forest text-[12px] font-bold text-white" data-id="element-277" data-mp="264bm5exu7phs">
          Enter the draw
        </span>
      </div>
    </div>;
}